<script setup lang="ts">
import MethodologyGridIcon from './../../../assets/CaseSpainMethodologyGridIcon.svg'

const props = defineProps<{
  text: string
  customClass?: string
  blockId?: string
}>()

const isMethodologyGrid: boolean | undefined | null = props.blockId?.includes('methodology-grid')
</script>

<template>
  <div>
    <div
      v-if="text && !isMethodologyGrid"
      class="flex flex-row border-t border-dashed justify-between lowercase tracking-widest font-light [font-variant:small-caps] font-alexandria pt-1"
      :class="customClass"
    >
      <span>{{ text }}</span>
      <span v-if="!props.blockId?.includes('methodology-grid')">●</span>
    </div>
    <div v-if="text && isMethodologyGrid" class="flex items-center justify-center">
      <div class="relative inline-flex items-center justify-center">
        <img :src="MethodologyGridIcon" alt="" class="block h-10 w-10" />
        <span
          class="pointer-events-none absolute inset-0 flex items-center justify-center text-lg font-extrabold font-alexandria mt-2.5 mr-0.5 ml-0.5"
        >
          {{ text }}
        </span>
      </div>
    </div>
  </div>
</template>
